import { ImageProps } from "./image-props";

export const AssigneeAlvin24Image = (props: ImageProps) => {
    return (
        <img
            height={24}
            width={24}
            alt={props.alt}
            src="https://wac-cdn.atlassian.com/dam/jcr:53f89189-0cb5-4485-be73-bb0ad90f7796/illustrations-meeples-Simplified%20Meeples-Steve.svg"
            data-testid={props["data-testid"]}
            className={props.className}
        />
    );
};
